import { render, staticRenderFns } from "./DIASRealEstateSuostujat.vue?vue&type=template&id=46fd9b80&"
import script from "./DIASRealEstateSuostujat.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateSuostujat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports